import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ProductServiceService } from 'src/app/services/core/quickbook/product-services/product-service.service';

@UntilDestroy()

@Component({
  selector: 'app-batch-payment-modal',
  templateUrl: './batch-payment-modal.component.html'
})
export class BatchPaymentModalComponent implements OnInit {
  @Input() count = 0;
  @Input() loading = false;
  // emits the chosen Deposit To account, or undefined for QuickBooks' default (Undeposited Funds)
  @Output() confirm = new EventEmitter<{ name: string; value: string } | undefined>();
  @Output() closeModal = new EventEmitter<void>();

  accounts: any[] = [];
  accountId = '';

  constructor(private productService: ProductServiceService) { }

  ngOnInit(): void {
    this.productService.getAccount({ forPayment: 'true' }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      this.accounts = Array.isArray(data) ? data : (data?.results || []);
    });
  }

  onConfirm() {
    const account = this.accounts.find((a: any) => a.Id === this.accountId);
    this.confirm.emit(account && { name: account.Name, value: account.Id });
  }
}
